export enum QuizStatus {
  INITIALIZING = "initializing",
  OPENED = "opened",
  CLOSED = "closed",
  NOT_AVAILABLE = "not_available"
}